import { useContext } from 'react'
import { buildVectorTileLayerDefaultOptions } from '../utils'
import { VectorGrid } from './VectorGrid'
import LayersContext from '../../../contexts/Layers'
import { ForestHabitatPopup } from '../Popups/ForestHabitatPopup'
import { useLayerPopupHandler } from '../hooks'
import { api } from '../../../config'

const layerSource = 'protected_areas'
const layerName = 'forestHabitats'
const options = buildVectorTileLayerDefaultOptions(layerName, layerSource, { zIndex: 1 })
const url = `${api.host}/vector_tiles/${layerSource}/{z}/{x}/{y}.pbf`

export const ForestHabitatsLayer = () => {
  const { selected } = useContext(LayersContext)
  const active = selected.includes(layerName)

  const [popupProps, handleClick] = useLayerPopupHandler(active)

  return active ? (
    <>
      <VectorGrid url={url} options={options} onClick={handleClick} />
      {popupProps ? <ForestHabitatPopup {...popupProps} /> : null}
    </>
  ) : null
}
